import { Component, Input } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { LocalService } from '@app/@core/services/local.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { UserOrgService } from '@pics-core/rbac-users';
import { AlertService } from '@pics-core/rbac-users';
import { CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { HttpService } from '@app/@core/services/http.service';

@Component({
  selector: 'app-role-additional-fields',
   standalone: true,
  templateUrl: './role-additional-fields.component.html',
  styleUrls: ['./role-additional-fields.component.scss'],
  imports: [
    CommonModule,
    ReactiveFormsModule,   // ✅ THIS IS REQUIRED,
    DropdownModule,   // ✅ REQUIRED for <p-dropdown>
    InputTextModule
  ],
})

export class AdditionalRoleFieldsComponent {
    roleTypeList: any[] = [];
  duplicateRoleTypeList: any[] = [];
    userid: boolean;
   userFormEvents$: Subject<any>;
    @Input()
    set data(val: any) {
        if (val) {
            this._data = val.this;
        //     if (this._data.roleFormEvents$) {
        //     this.roleFormEvents$ = this._data.roleFormEvents$;
        // }
            if (this._data.roleForm) {
                this.initializeExtension();
                 this.patchExtensionData(this._data.roleForm.value);
                  this.listenToSubmit();
            }

        }
    }
    get data(): any {
        return this._data;
    }
    _data: any;
    destroy$ = new Subject<void>();

    constructor(
        private fb: FormBuilder,
        private httpService: HttpService
    ) { }

    ngOnInit() {
        this.getRoleTypeList();
    }

    getRoleTypeList() {
    this.httpService.get('/domain/lookup?requestType=ROLE_TYPE').subscribe(
      (res: any) => {
        if (res && res.data) {
          this.roleTypeList = res.data;
          this.duplicateRoleTypeList = [...this.roleTypeList];
        }
      },
      (error: any) => console.log('Error fetching role types:', error)
    );
  }

  listenToSubmit() {
  if (!this._data.roleFormEvents$) return;

  this._data.roleFormEvents$
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      const ctrl = this._data.roleForm.get('additionalFields.cd_role_type');
      if (!ctrl) return;

      ctrl.markAsTouched();
      ctrl.markAsDirty();
      ctrl.updateValueAndValidity();
    });
}

  searchRoleTypeList(event: Event) {
    const value = (event.target as HTMLInputElement).value.toLowerCase();
    this.duplicateRoleTypeList = this.roleTypeList.filter((a: any) => a?.value?.toLowerCase().startsWith(value));
  }

  resetRoleTypeList() {
    this.duplicateRoleTypeList = this.roleTypeList;
  }


initializeExtension() {
  const roleForm = this._data.roleForm;
  let additionalFields = roleForm.get('additionalFields') as FormGroup;

  if (!additionalFields) {
    additionalFields = this.fb.group({});
    roleForm.addControl('additionalFields', additionalFields);
  }

  if (!additionalFields.get('cd_role_type')) {
    additionalFields.addControl(
      'cd_role_type',
      new FormControl(null, Validators.required)
    );
  }
}

onRoleTypeClear() {
  const control = this._data.roleForm
    .get('additionalFields')
    ?.get('cd_role_type');

  control?.setValue(null);
  control?.markAsTouched();
  control?.markAsDirty();
}


 addDynamicControls() {
        const additionalFields = this._data.roleForm.get('additionalFields') as FormGroup;
        if (additionalFields) {
            if (!additionalFields.contains('cd_role_type')) additionalFields.addControl('cd_role_type', new FormControl(''));
        }
    }

    patchExtensionData(userData: any) {
        if (this._data.roleForm && this._data.roleForm.get('additionalFields')) {
     const additionalFields = this._data.roleForm.get('additionalFields') as FormGroup;
  if (additionalFields) {
    additionalFields.patchValue({
  cd_role_type: userData?.cd_role_type ?? null
});
  }
        }
    }
setupValidators() {
        const roleTypeControl = this._data.roleForm.get('additionalFields.cd_role_type');
         if (!roleTypeControl) return;
        if (roleTypeControl) {
            roleTypeControl.setValidators([Validators.required]);
            roleTypeControl.updateValueAndValidity({ emitEvent: false });
        }
    }

    
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
